import $ from 'jquery'
import _ from 'underscore'

export class TreeCreate {
  constructor(treeNode, treeConfig) {
    this.treeNode = treeNode
    this.treeConfig = $.extend({
      FId: 'pid',
      Id: 'id',
      rootId: '0'
    }, treeConfig)
    this.treeData = [] // 树状的树数据
    this.flatTreeData = [] // 扁平的树数据
  }
  // 树生成, 递归调用
  createTree(TreeNode, config, data, parent, _level, saveParent) {
    let treeData, flatTreeData, level, childLevel, pid
    treeData = []
    flatTreeData = []
    level = _level
    childLevel = _level + 1
    var i, l, val
    for (i = 0, l = data.length; i < l; i++) {
      val = data[i]
      if (parent === null) {
        pid = config.rootId
      } else {
        pid = parent[config.Id]
      }
      if (val[config.FId] === pid) {
        var t = {
          _expanded: true,
          _show: true,
          _level: level
        }
        if (saveParent) {
          t['_parent'] = parent
        }
        TreeNode.call(t, val)
        var child = this.createTree(TreeNode, config, data, $.extend(t, val), childLevel, saveParent)
        treeData.push(t)
        flatTreeData.push(t)
        if (child.treeData.length > 0) {
          treeData[treeData.length - 1].children = child.treeData
          flatTreeData.push.apply(flatTreeData, child.flatTreeData)
        } else {
          treeData[treeData.length - 1].children = []
        }
      }
    }
    return {
      treeData: treeData,
      flatTreeData: flatTreeData
    }
  }
  // 生成树
  create(data, saveParent) {
    var result = this.createTree(this.treeNode, this.treeConfig, data, null, 0, saveParent)
    this.treeData = result.treeData
    this.flatTreeData = result.flatTreeData
  }
  // 获取树状的树数据(深拷贝)
  getTreeData() {
    return $.extend(true, [], this.treeData)
  }
  // 获取树状的树数据(浅拷贝)
  getTreeDataNoDeep() {
    return $.extend([], this.treeData)
  }
  // 获取扁平的树数据(深拷贝)
  getFlatTreeData() {
    return $.extend(true, [], this.flatTreeData)
  }
  // 获取扁平的树数据(浅拷贝)
  getFlatTreeDataNoDeep() {
    return $.extend([], this.flatTreeData)
  }
}

// 转换左右值树数据为一父节点树的数据
export const changeLRTreeToTreeData = (data, codeName, layerStr) => {
  layerStr = layerStr || 'OrganizationLayer'
  codeName = codeName || 'OgCode'
  var qq = _.toArray(_.groupBy(data, layerStr))
  // 如果没自己.slice(1),最后生成绑定到0
  qq.forEach(function (list, i) {
    if (i === qq.length - 1) return true
    var nextList = qq[i + 1]
    list.forEach(function (item, k) {
      item.children = []
      nextList.forEach(function (nextItem) {
        if (nextItem.LeftNum > item.LeftNum && nextItem.RightNum < item.RightNum) {
          nextItem.pid = item[codeName]
          item.children.push(nextItem)
        }
      })
    })
  })
  qq[qq.length - 1].forEach(function (item, i) {
    item.children = []
  })

  var r = qq[0]
  r[0].pid = ''
  return r
}

export default {
  TreeCreate: TreeCreate,
  changeLRTreeToTreeData: changeLRTreeToTreeData
}



// WEBPACK FOOTER //
// ./src/components/common/tree.js